import * as React from 'react';

const SvgArrow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M6.66667 -2.03186e-05L5.49167 1.17498L10.1417 5.83331L-3.27835e-07 5.83331L-2.54983e-07 7.49998L10.1417 7.49998L5.48333 12.15L6.66667 13.3333L13.3333 6.66665L6.66667 -2.03186e-05Z'
      fill='black'
    />
  </svg>
);

export default SvgArrow;
